const pickShopSummary = shop => ({
  store_logo: shop?.store_logo || '',
  store_name: shop?.store_name || '',
  vip_code_jnt: shop?.vip_code_jnt || '',
})

export const sanitizeAccountForSession = account => ({
  user_id: account?.user_id,
  client_device_token: account?.client_device_token || '',
  shop: pickShopSummary(account?.shop),
})

export const sanitizeAccountListForSession = accounts =>
  Array.isArray(accounts) ? accounts.map(sanitizeAccountForSession) : []

export const clearLegacySensitiveStorage = () => {
  if (typeof window === 'undefined') return
  ;['token', 'device_token', 'verifyTokenExport', 'data_live_stream'].forEach(
    key => window.localStorage.removeItem(key),
  )
}
